import { DateTime } from 'luxon';

export const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/**
 * Compares an expiration date to the current date and time
 * @param {string} expirationDate - The expiration date in ISO (UTC) format.
 * @returns
 * - `hours`:The number of hours remaining until the date expires. If the date has already expired, returns 0.
 */
export function compareExpiration(expirationDate: string) {
  const dateNow = DateTime.now().setZone(timezone);

  const dateTimezoneFormated = DateTime.fromISO(expirationDate, {
    zone: 'utc',
  }).setZone(timezone);

  const dateIsExpired = dateNow > dateTimezoneFormated;

  let hoursUntilExpiration = 0;
  if (!dateIsExpired) {
    hoursUntilExpiration = dateTimezoneFormated.diff(dateNow, 'hours').hours;
  }

  return {
    hours: hoursUntilExpiration > 0 ? Math.floor(hoursUntilExpiration) : 0,
  };
}
